import { Action } from '@ngrx/store';
import { MemberInterface } from '@app/core/_models/member-interface';

export enum MemberActions {
  LOAD_MEMBER = '[Member] Load member',
  MEMBER_LOADED = '[Member] Member loaded',
  CLEAR_MEMBER = '[Member] Member cleared',
  MEMBER_FETCHED = '[Member] Member fetch started',
  BASIC_MEMBER_FETCHED = '[Member] Basic member fetch started',
  LOAD_BASIC_MEMBER = '[Member] Load basic member',
}

export class LoadMember implements Action {
  public readonly type = MemberActions.LOAD_MEMBER;

  constructor(public force = false) {}
}

export class MemberLoaded implements Action {
  public readonly type = MemberActions.MEMBER_LOADED;

  constructor(public member: Partial<MemberInterface> | null) {}
}

export class ClearMember implements Action {
  public readonly type = MemberActions.CLEAR_MEMBER;
}

export class LoadBasicMember implements Action {
  public readonly type = MemberActions.LOAD_BASIC_MEMBER;
}

/**
 * Internal
 */
export class MemberFetchStarted implements Action {
  public readonly type = MemberActions.MEMBER_FETCHED;
}

/**
 * Internal
 */
export class BasicMemberFetchStarted implements Action {
  public readonly type = MemberActions.BASIC_MEMBER_FETCHED;
}
